export function createMoneyBox(): MoneyBox {
  return {
    today: 0,
    total: 0,
  };
}
